import LayerAdminService from "./LayerAdminService";

export default class MrnService extends LayerAdminService {
  private _lbBaseUrl = process.env.REACT_APP_LB_URL;

  public async Import(file: File): Promise<any> {
    const formData = new FormData();
    formData.append("uploadedFile", file);
    return this._client
      .post<any>(`${this._endpoint}/os:mrn`, formData, {
        baseURL: this._lbBaseUrl,
        timeout: 0,
      })
      .then((response) => {
        return response.data;
      });
  }

  public async Revert(): Promise<any> {
    return this._client
      .delete<any>(`${this._endpoint}/os:mrn/latest`)
      .then((response) => {
        return response.data;
      });
  }
}
